import { render, staticRenderFns } from "./AreaDetailsPopoutButton.vue?vue&type=template&id=bfaa5ab0&scoped=true"
import script from "./AreaDetailsPopoutButton.vue?vue&type=script&lang=ts"
export * from "./AreaDetailsPopoutButton.vue?vue&type=script&lang=ts"
import style0 from "./AreaDetailsPopoutButton.vue?vue&type=style&index=0&id=bfaa5ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa5ab0",
  null
  
)

export default component.exports